// Generated from packages/workflow-builder/iconConverter.js
import { SvgIconProps, createSvgIcon } from '@automata/mui-theme';
import { BrokenImageOutlined as BrokenImageOutlinedIcon } from '@automata/mui-theme/icons';
import { logger } from '@automata/utils';
import { memo } from 'react';

import { AgilentBiostackIcon } from './AgilentBiostackIcon';
import { AgilentBiotekIcon } from './AgilentBiotekIcon';
import { AgilentBravoIcon } from './AgilentBravoIcon';
import { AgilentPlateLocIcon } from './AgilentPlateLocIcon';
import { AgilentPlateLocSerialIcon } from './AgilentPlateLocSerialIcon';
import { AgilentSynergyH1Icon } from './AgilentSynergyH1Icon';
import { AltemisLabAlteCapSwiftIcon } from './AltemisLabAlteCapSwiftIcon';
import { AutomataBinIcon } from './AutomataBinIcon';
import { AutomataStackerIcon } from './AutomataStackerIcon';
import { AzentaAutomatedRollHeatSealerIcon } from './AzentaAutomatedRollHeatSealerIcon';
import { AzentaIntellixcapIcon } from './AzentaIntellixcapIcon';
import { AzentaIntelliXcapUncapperIcon } from './AzentaIntelliXcapUncapperIcon';
import { AzentaXpeelIcon } from './AzentaXpeelIcon';
import { BarcodeScannerIcon } from './BarcodeScannerIcon';
import { BeckmanBiomekIcon } from './BeckmanBiomekIcon';
import { BmgPheraStarFsxIcon } from './BmgPheraStarFsxIcon';
import { BmgPherastarIcon } from './BmgPherastarIcon';
import { BmgSpectrostarNanoIcon } from './BmgSpectrostarNanoIcon';
import { BrooksXpeelIcon } from './BrooksXpeelIcon';
import { CliniSafeYellowBinIcon } from './CliniSafeYellowBinIcon';
import { CytivaViaFreezeQuadIcon } from './CytivaViaFreezeQuadIcon';
import { FestoGantry1Icon } from './FestoGantry1Icon';
import { FestoGantry2Icon } from './FestoGantry2Icon';
import { FormulatrixMantisIcon } from './FormulatrixMantisIcon';
import { HamiltonStarIcon } from './HamiltonStarIcon';
import { HamiltonStarletIcon } from './HamiltonStarletIcon';
import { HettichRotina380RoboticIcon } from './HettichRotina380RoboticIcon';
import { HettichSbs300Icon } from './HettichSbs300Icon';
import { InhecoOdtcIcon } from './InhecoOdtcIcon';
import { InhecoScilaco2Icon } from './InhecoScilaco2Icon';
import { InhecoTeleshake95ACIcon } from './InhecoTeleshake95ACIcon';
import { KbioUltrasealeProIcon } from './KbioUltrasealeProIcon';
import { LiconicLiCotelLpx440Icon } from './LiconicLiCotelLpx440Icon';
import { LiconicLiCotelLPx740Icon } from './LiconicLiCotelLPx740Icon';
import { LiconicStoreXstx110Icon } from './LiconicStoreXstx110Icon';
import { LiconicStoreXstx56Icon } from './LiconicStoreXstx56Icon';
import { LiconicStx220Icon } from './LiconicStx220Icon';
import { NexcelomCellacaMxIcon } from './NexcelomCellacaMxIcon';
import { QInstrumentsBioShake3000Icon } from './QInstrumentsBioShake3000Icon';
import { QinstrumentsBioshakeIcon } from './QinstrumentsBioshakeIcon';
import { QInstrumentsColdPlateIcon } from './QInstrumentsColdPlateIcon';
import { RevvityEnvisionXciteIcon } from './RevvityEnvisionXciteIcon';
import { SptLabtechDragonflyIcon } from './SptLabtechDragonflyIcon';
import { SptLabtechXl100Icon } from './SptLabtechXl100Icon';
import { TecanHydroSpeedIcon } from './TecanHydroSpeedIcon';
import { TecanSparkIcon } from './TecanSparkIcon';
import { ThermoFisherAutomatedThermalCyclerIcon } from './ThermoFisherAutomatedThermalCyclerIcon';
import { ThermoFisherCytomat10cIcon } from './ThermoFisherCytomat10cIcon';
import { ThermoFisherCytomat2c425Icon } from './ThermoFisherCytomat2c425Icon';
import { ThermoFisherCytomatIcon } from './ThermoFisherCytomatIcon';
import { ThermoFisherFlouroskanIcon } from './ThermoFisherFlouroskanIcon';
import { ThermoFisherKingFisherApexIcon } from './ThermoFisherKingFisherApexIcon';
import { ThermoFisherMultidropIcon } from './ThermoFisherMultidropIcon';
import { ThermoFisherQuantStudioIcon } from './ThermoFisherQuantStudioIcon';
import { ZiathMirage2dIcon } from './ZiathMirage2dIcon';

export {
  AgilentBiostackIcon,
  AgilentBiotekIcon,
  AgilentBravoIcon,
  AgilentPlateLocIcon,
  AgilentPlateLocSerialIcon,
  AgilentSynergyH1Icon,
  AltemisLabAlteCapSwiftIcon,
  AutomataBinIcon,
  AutomataStackerIcon,
  AzentaAutomatedRollHeatSealerIcon,
  AzentaIntelliXcapUncapperIcon,
  AzentaIntellixcapIcon,
  AzentaXpeelIcon,
  BarcodeScannerIcon,
  BeckmanBiomekIcon,
  BmgPheraStarFsxIcon,
  BmgPherastarIcon,
  BmgSpectrostarNanoIcon,
  BrooksXpeelIcon,
  CliniSafeYellowBinIcon,
  CytivaViaFreezeQuadIcon,
  FestoGantry1Icon,
  FestoGantry2Icon,
  FormulatrixMantisIcon,
  HamiltonStarIcon,
  HamiltonStarletIcon,
  HettichRotina380RoboticIcon,
  HettichSbs300Icon,
  InhecoOdtcIcon,
  InhecoScilaco2Icon,
  InhecoTeleshake95ACIcon,
  KbioUltrasealeProIcon,
  LiconicLiCotelLPx740Icon,
  LiconicLiCotelLpx440Icon,
  LiconicStoreXstx110Icon,
  LiconicStoreXstx56Icon,
  LiconicStx220Icon,
  NexcelomCellacaMxIcon,
  QInstrumentsBioShake3000Icon,
  QInstrumentsColdPlateIcon,
  QinstrumentsBioshakeIcon,
  RevvityEnvisionXciteIcon,
  SptLabtechDragonflyIcon,
  SptLabtechXl100Icon,
  TecanHydroSpeedIcon,
  TecanSparkIcon,
  ThermoFisherAutomatedThermalCyclerIcon,
  ThermoFisherCytomatIcon,
  ThermoFisherCytomat10cIcon,
  ThermoFisherCytomat2c425Icon,
  ThermoFisherFlouroskanIcon,
  ThermoFisherKingFisherApexIcon,
  ThermoFisherMultidropIcon,
  ThermoFisherQuantStudioIcon,
  ZiathMirage2dIcon,
};

export const getIcon = (iconName: string): ReturnType<typeof createSvgIcon> => {
  switch (iconName) {
    case 'agilentbiostack':
      return AgilentBiostackIcon;
    case 'agilentbiotek':
    case 'agilentlhc':
      return AgilentBiotekIcon;
    case 'agilentbravo':
      return AgilentBravoIcon;
    case 'agilentplateloc':
      return AgilentPlateLocIcon;
    case 'agilentplatelocserial':
      return AgilentPlateLocSerialIcon;
    case 'agilentsynergyh1':
      return AgilentSynergyH1Icon;
    case 'altemislabaltecapswift':
      return AltemisLabAlteCapSwiftIcon;
    case 'automatabin':
      return AutomataBinIcon;
    case 'automatastacker':
      return AutomataStackerIcon;
    case 'azentaautomatedrollheatsealer':
      return AzentaAutomatedRollHeatSealerIcon;
    case 'azentaintellixcapuncapper':
      return AzentaIntelliXcapUncapperIcon;
    case 'azentaintellixcap':
      return AzentaIntellixcapIcon;
    case 'azentaxpeel':
      return AzentaXpeelIcon;
    case 'barcodescanner':
      return BarcodeScannerIcon;
    case 'beckmanbiomek':
      return BeckmanBiomekIcon;
    case 'bmgpherastarfsx':
      return BmgPheraStarFsxIcon;
    case 'bmgpherastar':
      return BmgPherastarIcon;
    case 'bmgspectrostarnano':
      return BmgSpectrostarNanoIcon;
    case 'brooksxpeel':
      return BrooksXpeelIcon;
    case 'clinisafeyellowbin':
      return CliniSafeYellowBinIcon;
    case 'cytivaviafreezequad':
      return CytivaViaFreezeQuadIcon;
    case 'festogantry1':
      return FestoGantry1Icon;
    case 'festogantry2':
      return FestoGantry2Icon;
    case 'formulatrixmantis':
      return FormulatrixMantisIcon;
    case 'hamiltonstar':
      return HamiltonStarIcon;
    case 'hamiltonstarlet':
      return HamiltonStarletIcon;
    case 'hettichrotina380robotic':
      return HettichRotina380RoboticIcon;
    case 'hettichsbs300':
      return HettichSbs300Icon;
    case 'inhecoodtc':
      return InhecoOdtcIcon;
    case 'inhecoscilaco2':
      return InhecoScilaco2Icon;
    case 'inhecoteleshake95ac':
      return InhecoTeleshake95ACIcon;
    case 'kbioultrasealepro':
      return KbioUltrasealeProIcon;
    case 'liconiclicotellpx740':
      return LiconicLiCotelLPx740Icon;
    case 'liconiclicotellpx440':
      return LiconicLiCotelLpx440Icon;
    case 'liconicstorexstx110':
      return LiconicStoreXstx110Icon;
    case 'liconicstorexstx56':
      return LiconicStoreXstx56Icon;
    case 'liconicstx220':
      return LiconicStx220Icon;
    case 'nexcelomcellacamx':
      return NexcelomCellacaMxIcon;
    case 'qinstrumentsbioshake3000':
      return QInstrumentsBioShake3000Icon;
    case 'qinstrumentscoldplate':
      return QInstrumentsColdPlateIcon;
    case 'qinstrumentsbioshake':
      return QinstrumentsBioshakeIcon;
    case 'revvityenvisionxcite':
      return RevvityEnvisionXciteIcon;
    case 'sptlabtechdragonfly':
      return SptLabtechDragonflyIcon;
    case 'sptlabtechxl100':
      return SptLabtechXl100Icon;
    case 'tecanhydrospeed':
      return TecanHydroSpeedIcon;
    case 'tecanspark':
      return TecanSparkIcon;
    case 'thermofisherautomatedthermalcycler':
      return ThermoFisherAutomatedThermalCyclerIcon;
    case 'thermofishercytomat':
      return ThermoFisherCytomatIcon;
    case 'thermofishercytomat10c':
      return ThermoFisherCytomat10cIcon;
    case 'thermofishercytomat2c425':
      return ThermoFisherCytomat2c425Icon;
    case 'thermofisherflouroskan':
      return ThermoFisherFlouroskanIcon;
    case 'thermofisherkingfisherapex':
      return ThermoFisherKingFisherApexIcon;
    case 'thermofishermultidrop':
      return ThermoFisherMultidropIcon;
    case 'thermofisherquantstudio':
      return ThermoFisherQuantStudioIcon;
    case 'ziathmirage2d':
      return ZiathMirage2dIcon;
    default:
      logger.log(`no icon for iconName ${iconName}`);
      return BrokenImageOutlinedIcon;
  }
};

export const Icon = memo(function Memoized({
  iconType,
  ...otherProps
}: SvgIconProps & { iconType: string }) {
  const Icon = getIcon(iconType.replace(/[-_]/g, ''));
  return <Icon style={{ fill: 'currentColor' }} {...otherProps} />;
});
